import themeColors from '@/assets/theme/colors'

const classes = {
  embla: {
    position: 'relative' as 'relative',
    backgroundColor: 'transparent',
    width: '100%'
  },
  emblaViewport: {
    overflow: 'hidden',
    borderRadius: '10px'
  },
  emblaContainer: {
    display: 'flex',
    alignItems: 'stretch'
  },
  emblaSlide: {
    position: 'relative' as 'relative',
    flex: '0 0 100%',
    minWidth: 0,
    boxSizing: 'border-box' as 'border-box'
  },
  emblaButton: {
    outline: 0,
    cursor: 'pointer',
    backgroundColor: 'rgba(255,255,255,0.9)',
    boxShadow: '0 1px 6px rgba(0,0,0,0.18)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    touchAction: 'manipulation',
    position: 'absolute' as 'absolute',
    top: '50%',
    zIndex: 20,
    transform: 'translateY(-50%)',
    border: 0,
    width: '34px',
    height: '34px',
    padding: 0
  },
  arrowButtonColor: {
    color: themeColors.gray.dark,
    '&:hover': {
      color: themeColors.info.main
    }
  },
  dots: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.5rem',
    marginTop: '0.9rem'
  }
}

export default classes
